import PropertyInput from "../components/inputs/input-property.tsx";
import {H, ViewCopy, ViewDialog} from "../components/view.tsx";
import { useStore } from "../state/state.ts";
import { InputVerbrauchCurrent } from "../components/inputs/input_verbrauch_current.tsx";
import { InputVerbrauchsEinheitCurrent } from "../components/inputs/input_verbrauchs_einheit_current.tsx";

export default function ViewBase3() {
   return (<ViewDialog ><ViewBase3Inner/></ViewDialog>)
}

export function ViewBase3Inner() {
   const _verbrauchseinheit_oel = useStore((state)=>state.verbrauchseinheit_oel_current);
   const _verbrauchseinheit_gas = useStore((state)=>state.verbrauchseinheit_gas_current);
   const _verbrauchseinheit_holz = useStore((state)=>state.verbrauchseinheit_holz_current);
   const _verbrauchseinheit_andere = useStore((state)=>state.verbrauchseinheit_andere_current);
   const _heizung = useStore((state)=>state.heizung);

   return (<>
            <ViewCopy><H>Wie heizen Sie aktuell?</H></ViewCopy>
            <PropertyInput placeholder_prefix="z.B." type="heizung"/>
            <InputVerbrauchsEinheitCurrent />
            <PropertyInput placeholder_prefix="z.B." type="energie_kosten_current"/>
            <InputVerbrauchCurrent />
            <p className="input_hint">Liegt der tatsächliche Verbrauch vor, kann dieser hier eingetragen und zur weiteren Berechnung genutzt werden. In diesem Fall bleibt dieser Verbrauch auch bei Eingabe bereits durchgeführter Sanierungen unverändert.</p>
         </>)
}
